import React, { Component } from 'react';
import { string, bool, func } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';

import { injectIntl, intlShape } from '../../../util/reactIntl';
import { propTypes } from '../../../util/types';

import { Form, FieldTextInput } from '../../../components';

import css from './SendMessageForm.module.css';

class SendMessageFormComponent extends Component {
  constructor(props) {
    super(props);
  }

  handleSubmit(x) {}

  render() {
    return (
      
      <FinalForm
        {...this.props}
        render={formRenderProps => {
          const { handleSubmit, form } = formRenderProps;

          const handleChange = (x, form) => {
            const state = form.getState();
            this.props.onBlur({ trackingNumber: state.values });
          };

          return (
            <Form className={css.trackingForm} onSubmit={values => handleSubmit(values)}>
              <div className={css.orderHeadingWithStatus}>
                <h3>Tracking Details</h3> <div className={css.fontLight}> Optional</div>
              </div>
              <FieldTextInput
                inputRootClass={css.trackingField}
                type="text"
                id="trackngNumber"
                name="number"
                label="Tracking Number"
                placeholder={'tracking number'}
                onBlur={x => handleChange(x, form)}
              />
              <FieldTextInput
                inputRootClass={css.trackingField}
                type="text"
                id="trackingProvider"
                label="Provider"
                name="provider"
                placeholder={'Tracking provider'}
                onBlur={x => handleChange(x, form)}
              />
              <FieldTextInput
                inputRootClass={css.trackingField}
                type="text"
                id="trackingLink"
                label="Tracking Url"
                name="link"
                placeholder={'Tracking Url'}
                onBlur={x => handleChange(x, form)}
              />
            </Form>
          );
        }}
      />
    );
  }
}


SendMessageFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  inProgress: bool,

  messagePlaceholder: string,
  onBlur: func,
  sendMessageError: propTypes.error,

  // from injectIntl
  intl: intlShape.isRequired,
};

const TrackingNumberForm = compose(injectIntl)(SendMessageFormComponent);

TrackingNumberForm.displayName = 'SendMessageForm';

export default TrackingNumberForm;
